import React, { Component} from 'react';
import { string } from 'prop-types';

import m from 'moment';
import s from './AppointmentDateContainer.css';


export default class AppointmentDateContainer extends Component {
  static defaultProps = {
    dateFormat: 'YYYY-MM-DD'
  };

  static propTypes = {
    date: string,
    dateFormat: string,
  };

  render() {
    const date = m(this.props.date, this.props.dateFormat);
    const dayOfWeek = date.format('dddd');
    const dayOfMonth = date.format('DD');
    const monthYear = date.format('MMM YYYY');

    return (
      <section className={s.component}>
        <h4 className={s.item}>{dayOfWeek}</h4>
        <h4 className={s.item + ' ' + s.dayOfMonth}>{dayOfMonth}</h4>
        <h4 className={s.item}>{monthYear}</h4>
      </section>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/AppointmentDate/AppointmentDateContainer.js